import { useEffect, useState } from 'react';
import useVideoContext from './useVideoContext';
import { Logger } from '../utils';

export default function useIsRemoteParticipantReconnecting() {
    const { room } = useVideoContext();
    const [isReconnecting, setIsReconnecting] = useState(false);
    useEffect(() => {
        const handleReconnecting = (remoteParticipant) => {
            Logger("UI.Twilio.RemoteParticipant.Reconnecting", new Date(), { participant: remoteParticipant });
            setIsReconnecting(true);
        };

        const handleReconnected = (remoteParticipant) => {
            Logger("UI.Twilio.RemoteParticipant.Reconnected", new Date(), { participant: remoteParticipant });
            setIsReconnecting(false);
        };

        room.on('participantReconnecting', handleReconnecting);
        room.on('participantReconnected', handleReconnected);
        return () => {
            room.off('participantReconnecting', handleReconnecting);
            room.off('participantReconnected', handleReconnected);
        };
    }, [room]);

    return isReconnecting;
}
